import StringParagraph from './StringParagraph';

const StringTitle = ({
    children,
    space = false
}: {
    children: string;
    space?: boolean;
}): React.JSX.Element => {
    return (
        <StringParagraph space={space} className="h6">
            {children}
        </StringParagraph>
    );
};

export default StringTitle;
